import NewAudioPlayer from "./AudioPlayer";
import "react-h5-audio-player/lib/styles.css";
import { Link } from "react-router-dom";

const Album = ({ info, title, id, img, file, description }) => {
  return (
    <div style={{ width: "100%", paddingBottom: "12%" }}>
      {info ? (
        info[0].title == "Shpilkes" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/shpilkes"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Potion Pushas" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/potion-pushas"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Alistair" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/alistair"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Sprout" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/sprout"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Resurgence of the Storm" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/resurgence-of-the-storm"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Stalling" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/stalling"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "The Dream Factory" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/the-dream-factory"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Beach Trip!" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/beach-trip"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "A Spell To Break" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/a-spell-to-break"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Afterlife" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/afterlife"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Across The Astral Sea: Tekha" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/across-the-astral-sea-tekha"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Broadway Blues" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/broadway-blues"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Claws and Order" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/claws-and-order"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Shuriken Saga" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/shuriken-saga"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Mixed Jams (from Beat Tender)" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/mixed-jams"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Puddle" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/puddle"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Survivors" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/survivors"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Upstream" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/upstream"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Starting Line" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/starting-line"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "The Moon Stole My Stripes" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/the-moon-stole-my-stripes"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Roger Williams" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/roger-williams"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Reach" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/reach"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "Serein" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/serein"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : info[0].title == "The Magical Unicorn Tales" ? (
          <Link
            style={{ textDecoration: "none", color: "gray" }}
            to="/music/unicorn"
          >
            <img
              style={{ width: "100%", paddingBottom: "5%" }}
              alt="album cover"
              loading="lazy"
              decoding="async"
              src={img}
            />
          </Link>
        ) : (
          <img
            style={{ width: "100%", paddingBottom: "5%" }}
            alt="album cover"
            loading="lazy"
            decoding="async"
            src={img}
          />
        )
      ) : (
        <img
          style={{ width: "100%", paddingBottom: "5%" }}
          alt="album cover"
          loading="lazy"
          decoding="async"
          src={img}
        />
      )}

      {file ? (
        <div style={{ paddingBottom: "5%" }}>
          <NewAudioPlayer
            trackName={title}
            songs={file ? file : ""}
            trackInfo={info}
          />
        </div>
      ) : (
        <></>
      )}
      <p style={{ color: "white", fontFamily: "Georgia" }}>
        <b>
          {title}
          <br />
        </b>
        <i>{description}</i>
        {info ? (
          info[0].title == "Shpilkes" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/shpilkes"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Potion Pushas" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/potion-pushas"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Alistair" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/alistair"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Stalling" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/stalling"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "The Dream Factory" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/the-dream-factory"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Beach Trip!" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/beach-trip"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Afterlife" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/afterlife"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "A Spell To Break" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/a-spell-to-break"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Across The Astral Sea: Tekha" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/across-the-astral-sea-tekha"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Resurgence of the Storm" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/resurgence-of-the-storm"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Sprout" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/sprout"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Broadway Blues" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/broadway-blues"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Claws and Order" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/claws-and-order"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Shuriken Saga" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/shuriken-saga"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Mixed Jams (from Beat Tender)" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/mixed-jams"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Puddle" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/puddle"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Upstream" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/upstream"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Starting Line" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/starting-line"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "The Moon Stole My Stripes" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/the-moon-stole-my-stripes"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Roger Williams" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/roger-williams"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Reach" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/reach"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Serein" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/serein"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "The Magical Unicorn Tales" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/unicorn"
              >
                Learn more...
              </Link>
            </>
          ) : info[0].title == "Survivors" ? (
            <>
              <br />
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/music/survivors"
              >
                Learn more...
              </Link>
            </>
          ) : (
            <>
              <br />
              <br />
            </>
          )
        ) : (
          <>
            <br />
            <br />
          </>
        )}
      </p>
    </div>
  );
};

export default Album;
